import api from "./api";

export async function fetchQuizLeaderboard(params = {}) {
  const response = await api.get("/quiz/get-quiz-leaderboard-data", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
